<template>
    <div class="field">
        <label v-if="label" class="field-label">{{label}}</label>
        <label class="field-switch-body" :for="name">
            <input type="checkbox" class="field-switch" :disabled="disabled" :id="name" :value="value" :checked="isChecked" @change="change"/>
            <span class="field-switch-handle"></span>
        </label>
    </div>
</template>

<script>
    import shortid from 'shortid';

    export default {
        name: 'v-toggle',
        model: {
            // here we redefine what property herein
            // the v-model directive should use as the actual `model`
            prop: 'selected',
            // and we tell it to listen for `input` events (see below)
            event: 'input',
        },
        props: {
            label: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                default: () => shortid.generate(),
            },
            caption: {
                type: String,
                default: null,
            },
            selected: { // this is the actual model for the component
                type: [Array, String, Number, Boolean],
            },
            value: {
                type: [String, Boolean],
                default: 'on',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            isChecked() {
                if (this.selected === null) {
                    return false;
                }
                if (Array.isArray(this.selected)) {
                    return this.selected.includes(this.value);
                }
                return this.selected === this.value;
            },
        },
        methods: {
            getModelValue() {
                if (Array.isArray(this.selected)) {
                    // copy array to prevent mutation on property
                    const copiedModel = this.selected.slice();
                    if (this.isChecked) {
                        // uncheck
                        copiedModel.splice(this.selected.indexOf(this.value), 1);
                    } else {
                        // check
                        copiedModel.push(this.value);
                    }
                    return copiedModel;
                }
                return !this.isChecked;
            },
            change() {
                // we trigger the event (input) we declared in the `model`
                // block above to let the `v-model` directive know
                // the model property is to be mutated in the parent
                // component
                this.$emit('input', this.getModelValue());
            },
        },
    };
</script>
